import { Textarea } from './Textarea';

// TODO: in v9, move styled() from Textarea.jsx to here
export var StyledTextarea = Textarea;